import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'onefaceui-react-components';
import { checkPermissions, getResourceTo } from 'react/utils/utils';
import { ModalFooter } from './styles';
import ViewStopButton from './ViewStopButton';
import EditStopButton from './EditStopButton';

/**
 * Footer component for the Stop Details modal
 * Follows the Single Responsibility Principle by focusing only on
 * rendering the footer and its buttons
 */
function StopDetailModalFooter({ stopDetail, stopStatus, closeModal }) {
  const enableEditButton = (stopStatus === 'PENDING'
    && (checkPermissions('ROUTE_UPDATE_STOP') || checkPermissions('ROUTE_REMOVE_STOP')));

  return (
    <ModalFooter justifyContent="flex-end" gap={12}>
      <Button
        dataTestId="close-modal-button"
        variant="secondary"
        onClick={closeModal}
      >
        {getResourceTo('default.button.cancel')}
      </Button>

      {enableEditButton && <EditStopButton stopDetail={stopDetail} />}

      <ViewStopButton stopDetail={stopDetail} />
    </ModalFooter>
  );
}

StopDetailModalFooter.propTypes = {
  stopDetail: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    route: PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    })
  }),
  stopStatus: PropTypes.string,
  closeModal: PropTypes.func.isRequired
};

StopDetailModalFooter.defaultProps = {
  stopDetail: null,
  stopStatus: ''
};

export default StopDetailModalFooter;
